/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CashEventDto
 */
export interface CashEventDto {
    /**
     * 
     * @type {boolean}
     * @memberof CashEventDto
     */
    success: boolean;
}

/**
 * Check if a given object implements the CashEventDto interface.
 */
export function instanceOfCashEventDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;

    return isInstance;
}

export function CashEventDtoFromJSON(json: any): CashEventDto {
    return CashEventDtoFromJSONTyped(json, false);
}

export function CashEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CashEventDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
    };
}

export function CashEventDtoToJSON(value?: CashEventDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
    };
}

